module.exports = __webpack_public_path__ + "static/media/logout.e676462d.svg";